import React from 'react';
import './App.css';
import { Routes, Route, useLocation } from 'react-router-dom';
import Header from './cmp/header';
import MySidebar from './cmp/nav';
import Login from './cmp/login';
import Dashboard from './cmp/dashboard';
import AdminProfile from './cmp/profile';
import Doctors from './cmp/doctors';
import Patients from './cmp/patients';
import UserDetails from './cmp/users_detail';
import SendNotification from './cmp/send_notification';
import ScheduledNotifications from './cmp/scheduled-notifications';
import Withdrawals from './cmp/withdrawals';
import Articles from './cmp/articles';
import AddArticle from './cmp/add-article';
import Products from './cmp/products';
import AddProduct from './cmp/add-product';
import Affiliates from './cmp/affiliates';
import AddAffiliate from './cmp/add-affiliate';
import AdminContact from './cmp/contact';
import Videos from './cmp/videos';
import AddVideo from './cmp/add-video';
import PlayVideo from './cmp/play-video';
import Recipes from './cmp/recipes';
import AddRecipe from './cmp/add-recipe';
import MindArticles from './cmp/mind-articles';
import AdminAddMindArticle from './cmp/add-mind-article';
import MedicalTidbits from './cmp/medical-tidbits';
import AddMedicalTidbit from './cmp/add-medical-tidbit';
import Quizzes from './cmp/quizzes';
import Analytics from './cmp/analytics';
import AdminAppVersion from './cmp/app-version';
import AddQuiz from './cmp/add-quiz';

// Container for the login page
const LoginContainer = () => <Login />;

// Container for the main admin pages
const HomeContainer = () => {
  const location = useLocation();
  const background = location.state && location.state.background;

  return (
    <div style={{ display: 'flex', flexDirection: 'row', flex: 1 }}>
      <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
        <Header />
        <div style={{ display: 'flex', width: '100%' }}>
          <MySidebar />
          <div style={{ flex: 1 }}>
            <Routes location={background || location}>
              <Route path="/" element={<Products />} />
              <Route path="/profile" element={<AdminProfile />} />
              <Route path="/doctors" element={<Doctors />} />
              <Route path="/patients" element={<Patients />} />
              <Route path="/user-details" element={<UserDetails />} />
              <Route path="/send-notification" element={<SendNotification />} />
              <Route path="/scheduled-notifications" element={<ScheduledNotifications />} />
              <Route path="/withdrawals" element={<Withdrawals />} />
              <Route path="/articles" element={<Articles />} />
              <Route path="/add-article" element={<AddArticle />} />
              <Route path="/products" element={<Products />} />
              <Route path="/add-product" element={<AddProduct />} />
              <Route path="/affiliates" element={<Affiliates />} />
              <Route path="/add-affiliate" element={<AddAffiliate />} />
              <Route path="/contact" element={<AdminContact />} />
              <Route path="/videos" element={<Videos />} />
              <Route path="/add-video" element={<AddVideo />} />
              <Route path="/play-video" element={<PlayVideo />} />
              <Route path="/recipes" element={<Recipes />} />
              <Route path="/add-recipe" element={<AddRecipe />} />
              <Route path="/mind-articles" element={<MindArticles />} />
              <Route path="/add-mind-article" element={<AdminAddMindArticle />} />
              <Route path="/medical-tidbits" element={<MedicalTidbits />} />
              <Route path="/add-medical-tidbit" element={<AddMedicalTidbit />} />
              <Route path="/quizzes" element={<Quizzes />} />
              <Route path="/add-quiz" element={<AddQuiz />} />
              <Route path="/analytics" element={<Analytics />} />
              <Route path="/app-version" element={<AdminAppVersion />} />
            </Routes>

            {/* Modal Route Overlay */}
            {background && (
              <Routes>
                <Route path="/play-video" element={<PlayVideo />} />
              </Routes>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default function AdminApp() {
  return (
    <Routes>
      <Route path="/login" element={<LoginContainer />} />
      <Route path="/*" element={<HomeContainer />} />
    </Routes>
  );
}
